/**
 * MassDifferentialPassiveSkillEffect — Astral dense-path upgrade: knockback
 * on proximity stagger.
 *
 * Code-only passive. When this node unlocks, its effect value
 * (`contactKnockbackTiles: 0.5`) becomes visible to the resolver. The
 * actual knockback logic lives in DenseSkillEffect.handleProximityContact(),
 * which queries `resolver.getAdditiveEffect('dense', 'contactKnockbackTiles')`
 * after each stagger and fires knockback if the value is > 0.
 *
 * This class carries no runtime behavior — it is a pure marker that the
 * node is unlocked. The tree JSON provides the effect value; the resolver
 * aggregates it; Dense/Collapse consumes it.
 *
 * Pure logic — no Phaser dependencies.
 *
 * @see astral-spec.md § dense_knockback
 * @see ADR-064 (attunement shared systems architecture)
 */

import type { SkillEffect } from '../../SkillEffect.js';

// ---------------------------------------------------------------------------
// Skill effect
// ---------------------------------------------------------------------------

export class MassDifferentialPassiveSkillEffect implements SkillEffect {
  readonly skillId = 'dense_knockback';
  readonly type = 'passive' as const;
  readonly activationMode = 'instant' as const;

  // --- SkillEffect interface ---

  activate(): boolean { return false; }
  isActive(): boolean { return false; }
  update(_delta: number): void { /* passive — nothing to tick */ }
  destroy(): void { /* no-op marker passive */ }
}
